<script setup>
import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline';
import { useSearchStore } from '@/stores/search.js';
import { focusRing } from './navigationClasses.js';

const searchStore = useSearchStore();
</script>

<template>
    <button
        type="button"
        class="inline-flex size-8 items-center justify-center rounded-full bg-deep-teal-700 purple-theme:bg-purple-700 text-white hover:bg-deep-teal-900 purple-theme:hover:bg-purple-900 focus-visible:ring-offset-2 transition-colors"
        :class="focusRing"
        :aria-label="$t('components.navigation.search')"
        @click="searchStore.open()"
    >
        <MagnifyingGlassIcon
            class="size-5"
            aria-hidden="true"
        />
    </button>
</template>
